import axios from 'axios';
import React, { useEffect, useState } from 'react';
import CONFIG from '../../utils/config';
import { Tab, Tabs } from 'react-bootstrap';

const PillorsComp = (props) => {
    const { activeTab, setActiveTab, setExpandedCategoryId=()=>{} } = props;
const [pillors, setPillors] = useState([]);

    useEffect(() => {
        axios.get(CONFIG.API_URL_REAL_BROKER+'wp-json/root/v1/get-pillar') // Replace with your actual API endpoint
            .then(response => {
                if (response.data && response.data.status) {
                    setPillors(response.data.data.pillar);
                }
            })
            .catch(error => {
                console.error('Error fetching data:', error);
            });
    }, []);


    return (
        <Tabs
  id="pill-tabs"
  activeKey={activeTab}
  onSelect={(k) => {setExpandedCategoryId(null); setActiveTab(k);}}
  className="mb-3"
>
  <Tab eventKey="all" title="All" tabIndex={0}>
    {/* Content for "All" tab */}
  </Tab>

  {pillors && pillors.map((pill, index) => (
    <Tab key={index} tabIndex={0} eventKey={pill.id} title={pill.name}>
      {/* Content for {pill.name} tab */}
    </Tab>
  ))}
</Tabs>
    );
}
export default PillorsComp;